import styled, { css } from 'styled-components';

export const StyledTextAreaWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 5px;
  min-height: 44px;
  transition: border 0.3s;
`;

export const StyledTextArea = styled.textarea`
  ${({ theme }) => theme.fonts.mulishLight};
  font-size: 14px;
  line-height: 1;
  letter-spacing: -0.025em;
  color: ${({ theme, color }) => color ? color : theme.colors.darkGrey};
  border: 0;
  outline: 0;
  padding: 10px 15px;
  resize: ${({ resize }) => resize};
  border-radius: 5px;
  height: ${({ height }) => height}px;
  ::placeholder {
    color: ${({ theme }) => theme.colors.mediumGrey};
  };
`;

export const StyledTextAreaBottom = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledCounter = styled.div`
  ${({ theme }) => theme.fonts.mulishRegular};
  font-size: 11px;
  line-height: 1;
  letter-spacing: -0.025em;
  color: ${({ theme }) => theme.colors.mediumGrey};
  margin-top: 8px;
  margin-left: auto;
`;

export const StyledTextAreaContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  margin-bottom: 20px;
  ${({ disabled }) => disabled && css`
    pointer-events: none;
    opacity: 0.5;
  `};
  ${({ readonly }) => readonly && css`
    pointer-events: none;
    opacity: 0.7;
  `};
  ${({ error }) => error && css`
    ${StyledTextAreaWrapper} {
      border: 1px solid ${({ theme }) => theme.colors.error};
    };
  `};
  ${({ fullWidth }) => fullWidth && css`
    width: 100%;
    ${StyledTextArea} {
      width: 100%;
    };
  `};
  ${({ customStyle }) => customStyle && customStyle};
`;